var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.56 15.5205C117.398 14.2845 116.255 13.1115 116.255 13.1115H99.3184L94.7929 13.4535L92.3344 14.3055L91.7404 13.9905H84.6229L84.0499 14.871L71.3944 15.018L71.0794 14.2005L68.0209 13.614L67.3714 12.042L64.8154 11.6865L63.8509 10.743H61.5244C61.5244 10.743 61.1269 10.47 60.8119 8.94147C60.4969 7.41147 58.0459 8.09547 57.6079 8.57697C57.1699 9.05697 57.4174 10.4715 57.4174 10.4715C57.4174 10.4715 55.3429 10.7025 55.0294 10.7025C54.7159 10.7025 53.8909 11.331 53.8909 11.331L52.7239 10.629L51.0409 11.331L49.3924 10.6395L48.3034 11.331L47.6224 10.917L44.5309 10.7025L41.7649 11.8335H36.9874V11.037H34.8919L34.5049 11.8755H31.9159L30.9514 11.331L24.7579 11.2905L23.7439 11.541L22.6129 10.41H21.3349C21.3349 10.41 21.3139 9.02697 21.2839 8.59347C21.2539 8.15997 19.5124 7.68597 19.5124 7.68597L17.7949 8.56647V10.41L16.0714 12.798L15.2599 13.6155L13.8979 14.9775L12.6589 14.796L11.5939 14.265L11.0074 14.8515L10.1974 14.265H4.33387L3.30337 14.433L2.71387 15.3555L2.80687 18.624L3.67837 19.629H10.5934L10.6774 18.9795L12.0694 19.9995L11.0539 22.143V23.8605C11.0539 23.8605 11.9989 25.533 12.9574 27.2295C13.9159 28.926 14.8039 31.53 14.8039 31.53C14.8039 31.53 17.7124 40.62 18.1024 42.3195C18.4924 44.019 19.7524 45.498 19.7524 45.498C19.7524 45.498 22.4434 45.507 23.1649 45.366C23.8849 45.225 25.4434 44.2665 25.4434 44.2665C25.4434 44.2665 25.6324 43.3425 25.6144 43.0725C25.5964 42.8025 24.5494 36.534 24.5494 36.534C24.5494 36.534 23.3329 30.7755 22.3879 29.8275C21.4444 28.8795 20.9284 28.851 20.5984 27.8985C20.2684 26.946 20.9284 26.448 20.9284 26.448H22.8844L24.2809 25.5225L25.4419 25.8015L27.8014 25.8375C27.8014 25.8375 31.7539 25.8075 33.3049 26.139C34.8559 26.4705 36.3829 30.36 37.1449 31.095C37.9069 31.83 39.6319 31.9905 39.6319 31.9905L42.1039 32.1165L43.5559 32.6745L45.7069 32.6235L47.3149 33.102L48.8089 35.691L50.2609 36.8085L51.9304 40.2105L54.1159 46.977L53.1979 48.5865L53.2834 51.3255L54.5629 53.4585L56.4619 53.1825L66.3049 49.194C66.3049 49.194 68.2399 47.793 68.6059 46.878C68.9734 45.963 67.7104 43.8645 67.7104 43.8645C67.7104 43.8645 60.5974 30.7425 60.5224 30.5715C60.4474 30.4005 59.5354 28.371 60.1864 26.796C60.8374 25.221 64.2394 24.7665 64.2394 24.7665L67.1899 24.7395L67.3714 23.9295L67.6084 22.56L68.1679 22.308H81.9964L83.2249 21.4995L84.8449 22.0005L91.7179 21.8895L92.5354 21.7245C92.5354 21.7245 92.8804 23.532 93.5434 24.318C94.2064 25.104 94.8469 26.3025 94.8469 26.3025L94.4554 32.895C94.4554 32.895 93.6184 33.648 93.5059 33.6765C93.3934 33.7065 92.3329 34.962 92.3674 35.856C92.4019 36.7515 94.9939 42.4575 94.9939 42.4575L95.8249 43.3365L98.1994 43.509L108.392 41.3715L109.094 40.827H109.988C109.988 40.827 114.896 39.3945 115.548 39.09C116.201 38.7855 116.579 38.13 116.912 37.3515C117.245 36.5715 116.934 35.4585 116.934 35.4585L117.639 20.88C117.639 20.88 117.717 16.752 117.555 15.516L117.56 15.5205ZM48.6139 29.433C48.5014 30.0195 47.6089 30.7185 47.6089 30.7185L40.0384 30.858C40.0384 30.858 38.4454 30.9975 37.5799 28.5675C36.7144 26.1375 37.4119 24.936 37.4119 24.936H46.2394C46.2394 24.936 47.9989 25.5225 48.3904 26.445C48.7819 27.3675 48.7249 28.848 48.6139 29.4345V29.433Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4639 23.4555H67.3734",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 15.9825V17.3655V22.0575",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2891 22.0019V14.6624",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 17.3654H47.0085H82.5015V21.5279",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.008 17.3654V18.3314L45.709 19.4459H42.0625",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7705 20.5499H44.871L45.5835 20.8844H53.7135L54.8445 19.7534L55.9755 18.6224V17.3654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2207 19.4459H62.6802H63.6642L64.9647 18.5174V17.3654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6797 19.446C62.6797 19.446 63.4972 20.6745 63.5602 20.6745H71.7322L73.1062 19.2435L73.9117 18.405V17.364",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.501 18.4049H77.9755L77.179 19.1879H73.324",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2461 20.1404H76.1941L77.2006 21.0734H82.3756",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7093 19.446L44.4238 20.55",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0234 13.614V17.1135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.364 13.929V17.1135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5225 15.3644V17.3654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4211 10.4714H61.1291",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9413 17.1135H22.8838C22.8838 17.1135 21.6553 17.0295 21.6553 18.036C21.6553 19.0425 22.8838 19.0215 22.8838 19.0215H33.2758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.976H21.9355H33.619",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9353 14.976L19.3088 20.8845H17.7578",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4452 22.0574H30.0372C30.0372 22.0574 29.2272 22.0574 29.1987 23.2034C29.1702 24.3494 32.6067 25.8014 32.6067 25.8014C32.6067 25.8014 32.6622 24.5444 34.2552 24.2789C35.8482 24.0134 55.6827 24.2789 55.6827 24.2789",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3861 25.1174H57.8051H55.6826",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8052 25.1174C57.8052 25.1174 57.4137 27.5894 57.8052 29.0984C58.1967 30.6074 60.5427 35.8589 61.4367 37.4789C62.3307 39.0989 63.7272 42.1169 63.9507 43.1774C64.1742 44.2394 65.0397 45.1334 62.6802 46.3619C60.3192 47.5904 55.6827 49.7159 55.6827 49.7159L55.0272 51.3359L53.5032 52.0514L68.0232 45.2459",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5186 32.2725L23.1636 31.317",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5956 32.796L15.6621 33.204",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9314 33.5789L23.5764 32.6234",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0097 34.1039L16.0762 34.5119",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.335 34.887L23.98 33.93",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.412 35.4105L16.4785 35.8185",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5986 36.0089L24.2436 35.0519",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6774 36.5325L16.7439 36.9405",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9902 37.2345L24.6352 36.279",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0673 37.758L17.1338 38.1675",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 38.4599L24.7646 37.5494",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3671 38.9849L17.4336 39.3929",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5667 39.687L25.0106 38.7825",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6454 40.2104L17.7119 40.6184",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8594 40.9125L25.2119 40.0335",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9377 41.4359L18.0042 41.8454",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1572 42.1379L25.4422 41.2769",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M20.236 42.663L18.3025 43.071",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9033 28.902L16.7443 25.41H23.9803",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9296 26.4465H19.0681C19.0681 26.4465 16.8886 26.4435 17.1346 28.26C17.3806 30.0765 20.5381 30.357 21.1531 30.342C21.7681 30.327 22.3876 29.826 22.3876 29.826",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7578 21.528H23.7518C23.7518 21.528 25.8743 21.276 25.8743 23.442H29.1983",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7505 11.5394V13.3169C23.7505 13.3169 23.77 14.2634 23.0275 14.2634C22.285 14.2634 22.3885 13.3169 22.3885 13.3169V11.3309",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2207 14.2634H59.2752C59.2752 14.2634 59.3277 15.5204 61.7157 15.5204H67.8342",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8606 14.4315V19.446",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 14.5214V19.5374",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 14.613V19.6275",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46387 14.7029V19.7189",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66504 14.7944V19.8089",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86621 14.8859V19.9004",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.458 25.1174H108.594",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M109.012 33.2039H94.7939",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M100.213 25.1174V33.2039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.342 25.1174V33.2039",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7939 13.4534V25.1174",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M106.573 18.0825H96.1904V20.8845H107.514",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3193 19.446H106.951",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M107.755 26.3039H105.856V32.0024H107.755V26.3039Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9996 41.9625C97.3235 41.9625 97.5861 41.6999 97.5861 41.376C97.5861 41.0521 97.3235 40.7895 96.9996 40.7895C96.6757 40.7895 96.4131 41.0521 96.4131 41.376C96.4131 41.6999 96.6757 41.9625 96.9996 41.9625Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7769 32.0024C97.1008 32.0024 97.3634 31.7398 97.3634 31.4159C97.3634 31.092 97.1008 30.8294 96.7769 30.8294C96.453 30.8294 96.1904 31.092 96.1904 31.4159C96.1904 31.7398 96.453 32.0024 96.7769 32.0024Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4136 15.4785C96.7376 15.4785 97.0001 15.2159 97.0001 14.892C97.0001 14.5681 96.7376 14.3055 96.4136 14.3055C96.0897 14.3055 95.8271 14.5681 95.8271 14.892C95.8271 15.2159 96.0897 15.4785 96.4136 15.4785Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M90.001 19.0199C90.2206 19.0199 90.3985 18.8419 90.3985 18.6224C90.3985 18.4029 90.2206 18.2249 90.001 18.2249C89.7815 18.2249 89.6035 18.4029 89.6035 18.6224C89.6035 18.8419 89.7815 19.0199 90.001 19.0199Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0518 19.0199C86.2713 19.0199 86.4493 18.8419 86.4493 18.6224C86.4493 18.4029 86.2713 18.2249 86.0518 18.2249C85.8323 18.2249 85.6543 18.4029 85.6543 18.6224C85.6543 18.8419 85.8323 19.0199 86.0518 19.0199Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0354 9.64493C59.1688 9.64493 59.2769 9.5368 59.2769 9.40343C59.2769 9.27005 59.1688 9.16193 59.0354 9.16193C58.9021 9.16193 58.7939 9.27005 58.7939 9.40343C58.7939 9.5368 58.9021 9.64493 59.0354 9.64493Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5386 13.1954C52.643 13.1954 52.7276 13.1108 52.7276 13.0064C52.7276 12.9021 52.643 12.8174 52.5386 12.8174C52.4342 12.8174 52.3496 12.9021 52.3496 13.0064C52.3496 13.1108 52.4342 13.1954 52.5386 13.1954Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5191 9.23845C19.5614 9.23845 19.5956 9.2042 19.5956 9.16195C19.5956 9.1197 19.5614 9.08545 19.5191 9.08545C19.4769 9.08545 19.4426 9.1197 19.4426 9.16195C19.4426 9.2042 19.4769 9.23845 19.5191 9.23845Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M31.586 23.7764C31.7716 23.7764 31.922 23.626 31.922 23.4404C31.922 23.2549 31.7716 23.1044 31.586 23.1044C31.4004 23.1044 31.25 23.2549 31.25 23.4404C31.25 23.626 31.4004 23.7764 31.586 23.7764Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4422 25.1175C13.5425 25.1175 13.6237 25.0362 13.6237 24.936C13.6237 24.8357 13.5425 24.7545 13.4422 24.7545C13.342 24.7545 13.2607 24.8357 13.2607 24.936C13.2607 25.0362 13.342 25.1175 13.4422 25.1175Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9027 28.9018L11.0527 23.8588V22.1413L12.1837 19.7533H11.7652L11.0527 18.9778L10.5922 19.6273H3.6787C3.6787 19.6273 2.8402 18.9568 2.7142 18.3703C2.5882 17.7838 2.7142 15.3538 2.7142 15.3538C2.7142 15.3538 3.0907 14.3068 3.6787 14.2648H10.6762L11.0107 14.8513L11.5972 14.2648H12.2257L12.8122 14.9773H14.3212C14.3212 14.9773 14.8237 14.4748 14.9497 14.2648C15.0757 14.0548 15.3682 13.2178 15.7462 13.0078C16.1227 12.7978 16.6267 12.6313 16.8772 12.2533C17.1292 11.8768 17.5057 11.1643 17.7997 11.0383V8.56631C17.7997 8.56631 18.3022 7.81181 19.5172 7.68581C20.7322 7.55981 21.2767 8.56631 21.3187 9.02681C21.3607 9.48731 21.2347 10.4098 22.1152 10.4098C22.9957 10.4098 22.6177 10.4098 22.6177 10.4098L23.7487 11.5408L24.5452 11.2888L30.9562 11.3308L31.5847 11.8753H34.6852V11.0368H36.9892V11.8333H42.1432L43.6102 11.1628L44.0287 10.7023H47.4652L47.9257 11.3308H49.0567V10.8703L49.3912 10.6393H50.3557L50.6077 10.8073V11.3308H52.0747V10.8493L52.2952 10.6288H53.2492L53.3962 10.8493V11.2678H54.5272L54.8002 11.0368L55.0312 10.7023H57.2317L57.4207 10.4713V8.98331C57.4207 8.98331 57.7552 7.76831 59.0962 7.76831C60.4372 7.76831 60.8137 8.94131 60.8137 8.94131V10.5343L61.0657 10.7443H63.8527L64.8172 11.6878H67.3732L67.7287 12.0643V13.2583L68.0227 13.6138H69.0697L69.3637 13.9288H70.7887L71.0827 14.2018V14.7043L71.3977 15.0193H83.8012L84.0532 14.8723V14.2858L84.3052 13.9918H91.7437L92.0587 14.2438V14.4748L92.2267 14.6638H92.5417L92.7307 14.4748V14.2648L92.9407 14.0128L93.9457 13.9918L94.2397 13.6768C94.2397 13.6768 94.3447 13.2163 94.6582 13.1113H116.26C116.26 13.1113 117.956 13.7608 117.748 18.6643C117.538 23.5678 116.924 35.8588 116.924 35.8588C116.924 35.8588 117.706 38.5408 114.634 39.4903C111.56 40.4398 109.996 40.8313 109.996 40.8313H109.102L108.599 41.3338L98.2072 43.5133H96.0847L95.1907 42.8983L92.3977 36.4168L92.3422 34.9648L93.5152 33.6793C93.5152 33.6793 94.8562 33.4003 94.8562 32.3383V26.3038C94.8562 26.3038 94.6327 24.7393 93.7387 24.4048C92.8447 24.0703 92.7337 23.1763 92.7337 22.3933C92.7337 21.6103 92.0632 21.0523 91.7287 21.8908L84.2977 22.0018L83.8792 21.5263H82.9297L82.5382 21.8608L82.3432 22.3078H68.1802L67.6222 22.5598V24.2638L67.2037 24.7393H64.4932C64.4932 24.7393 60.9502 25.0183 60.0817 27.0298C59.2132 29.0413 61.6717 32.6728 61.6717 32.6728L68.3212 44.9653C68.3212 44.9653 69.7177 47.5348 66.8692 48.9328C64.0192 50.3293 55.7512 53.4583 55.7512 53.4583H54.5782C54.5782 53.4583 53.7397 52.7323 53.4052 51.7828C53.0707 50.8333 53.2372 48.0388 53.2372 48.0388C53.2372 48.0388 53.9077 47.5918 54.1312 46.9768C54.3547 46.3618 53.0137 43.0093 52.2877 41.1103C51.5617 39.2113 50.8912 37.3108 50.2762 36.8083C49.6612 36.3058 49.1032 36.3058 48.8242 35.6908C48.5452 35.0758 47.3722 32.6173 46.6447 32.6173C45.9172 32.6173 43.5712 32.6728 43.5712 32.6728L42.1192 32.1148C42.1192 32.1148 39.4372 32.3383 38.3197 31.8358C37.2022 31.3333 36.1972 30.2713 35.5267 29.2093C34.8562 28.1473 34.4647 27.0298 33.9067 26.5828C33.3487 26.1358 32.6212 25.8013 32.6212 25.8013L25.0777 25.8568L24.2962 25.5223L23.6812 25.5778L22.8997 26.4463H20.9437C20.9437 26.4463 20.1052 26.7268 20.5522 28.1908C20.9992 29.6563 22.1167 28.4818 23.1217 31.1638C24.1267 33.8458 25.4677 40.6063 25.5802 42.3388L25.6912 44.0713C25.6912 44.0713 24.8527 44.8528 23.4007 45.2998C21.9487 45.7468 19.9927 45.5788 19.9927 45.5788C19.9927 45.5788 19.4902 45.8023 18.3727 43.0093C17.2552 40.2163 14.4892 29.9143 13.9162 28.9018H13.9027Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5371 14.6623V21.5008",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M105.855 13.4533V15.7993L108.648 24.6838C108.648 24.6838 109.653 25.3543 109.653 26.0803V32.2258C109.653 32.2258 109.319 33.2308 108.201 33.7903C107.084 34.3483 107.252 36.5833 107.252 37.3663C107.252 38.1493 109.095 40.8298 109.095 40.8298",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4102 24.9359H46.2377C46.2377 24.9359 47.9972 25.5224 48.3887 26.4449C48.7802 27.3674 48.7232 28.8479 48.6122 29.4344C48.5012 30.0209 47.6072 30.7199 47.6072 30.7199L40.0367 30.8594C40.0367 30.8594 38.4437 30.9989 37.5782 28.5689C36.7127 26.1389 37.4102 24.9374 37.4102 24.9374V24.9359Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0601 24.9358C44.0601 24.9358 44.3946 26.5288 44.3946 27.3658C44.3946 28.2028 43.8921 29.3218 43.6686 29.4328C43.4451 29.5438 45.9036 29.6278 46.7136 29.1808C47.5236 28.7338 48.5016 27.6718 48.5016 27.6718C48.5016 27.6718 48.5391 26.3578 48.0531 25.9693C47.5671 25.5808 47.0211 24.9343 46.2381 24.9343H44.0586L44.0601 24.9358Z",
    fill: "#FAFAFB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 23.4403H22.5352C22.5352 23.4403 24.2947 23.3983 24.1282 25.1158",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M30.958 11.3307L34.3525 15.9822H53.7955L57.316 12.0432H67.3735",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3519 15.9824H33.2764V22.3934H68.1694",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3215 14.9758L12.1855 19.7533",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M16.571 23.4403L22.619 10.4083H17.7995",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6758 14.2634V18.9779",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M56.072 22.3932C56.072 22.3932 56.183 25.7472 54.173 27.8967C52.163 30.0462 49.166 31.6677 49.166 31.6677V34.2943L52.9445 35.9698L55.7375 42.9537H57.917C57.917 42.9537 60.71 42.8982 60.878 44.5737C61.046 46.2492 59.0345 46.8642 59.0345 46.8642L53.183 49.7142",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmg);
export default __webpack_public_path__ + "static/media/SMG.eaf98c1dd73c8d4a9bae7977f7ba84e6.svg";
export { ForwardRef as ReactComponent };